import React, { Component } from 'react';
import { Typography, message, Alert, Row, Col, Divider } from 'antd';
import { BankOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { connect } from "react-redux";
import axios from "axios";
import { ModalItem, ButtonItem, InputItem } from "../../../../Components/Items";

const { Text } = Typography;

class ModalConfirmarPagoTransferencia extends Component {
  state = {
    cargando: false,
    referenciaEscrita: "",
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.setState({ referenciaEscrita: "" });
    }
  }

  normalizar = (valor) => (valor || "").trim().toUpperCase();

  coincide = () => {
    const { venta } = this.props;
    if (!venta?.referencia) return false;
    return (
      this.normalizar(this.state.referenciaEscrita) ===
      this.normalizar(venta.referencia)
    );
  };

  confirmarPago = () => {
    const { venta, empresaId, headersToken, onSuccess } = this.props;
    if (!this.coincide()) return;

    this.setState({ cargando: true });

    axios
      .post(
        "ventasEcommerce/confirmarPagoTransferencia",
        {
          ventaId: venta._id,
          empresaId,
          referenciaConfirmada: this.state.referenciaEscrita,
        },
        { headers: headersToken },
      )
      .then((res) => {
        this.setState({ cargando: false });
        if (res.data.success) {
          message.success(
            res.data.alreadyApplied
              ? "El pago ya estaba registrado"
              : "Pago confirmado",
          );
          onSuccess();
        } else {
          message.warning(res.data.message || "No se pudo confirmar el pago.");
        }
      })
      .catch((err) => {
        this.setState({ cargando: false });
        message.error(
          err.response?.data?.message ||
            "Error al conectar con el servidor.",
        );
      });
  };

  render() {
    const { visible, onCancel, venta } = this.props;
    const { cargando, referenciaEscrita } = this.state;

    if (!venta) return null;

    const nombreCliente =
      `${venta.clienteOnline?.nombre || ""} ${venta.clienteOnline?.apellidoPaterno || ""}`.trim() ||
      venta.clienteOnline?.email ||
      "Cliente";

    return (
      <ModalItem
        title={<span><BankOutlined /> Confirmar Pago por Transferencia</span>}
        visible={visible}
        onCancel={onCancel}
        width={480}
        spinning={cargando}
      >
        <Alert
          message="Verifica la referencia antes de confirmar"
          description="Escribe la referencia exacta que aparece en el estado de cuenta bancario para esta venta. Esto evita confirmar pagos por error."
          type="warning"
          showIcon
          style={{ marginBottom: 15, marginTop: 15 }}
        />

        <div style={{ background: '#f5f5f5', padding: '15px', borderRadius: '8px', marginBottom: '15px' }}>
          <Row gutter={[0, 10]}>
            <Col span={24}>
              <Text type="secondary" style={{ fontSize: '12px' }}>Folio de Venta:</Text><br />
              <Text strong>{venta.serieNumero}</Text>
            </Col>
            <Col span={24}>
              <Text type="secondary" style={{ fontSize: '12px' }}>Cliente:</Text><br />
              <Text strong>{nombreCliente}</Text>
            </Col>
          </Row>
        </div>

        <Divider style={{ margin: '8px 0 15px' }} />

        <Text type="secondary" style={{ fontSize: '12px' }}>
          Referencia de la venta:
        </Text>
        <InputItem
          autoFocus
          placeholder="Escribe la referencia..."
          value={referenciaEscrita}
          onChange={(e) => this.setState({ referenciaEscrita: e.target.value })}
          onPressEnter={() => this.coincide() && this.confirmarPago()}
          style={{ marginBottom: 15, marginTop: 6 }}
        />

        <div style={{ textAlign: "right", marginBottom: 15 }}>
          <ButtonItem onClick={onCancel} blanco style={{ marginRight: 8 }}>Cancelar</ButtonItem>
          <ButtonItem
            type="primary"
            disabled={!this.coincide()}
            icon={<CheckCircleOutlined />}
            onClick={this.confirmarPago}
            verde
          >
            Confirmar pago
          </ButtonItem>
        </div>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalConfirmarPagoTransferencia);
